import React, { useState, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import Slot from './Slot';
import styles from './Slots.module.css';
import mainPageStyles from '../MainPage.module.css';

const getRandomStopIndex = () => Math.floor(Math.random() * 3); // Теперь у нас 3 уникальных элемента

const SlotsContainer: React.FC = () => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [stopIndexes, setStopIndexes] = useState([0, 0, 0]);

  const controls = [useAnimation(), useAnimation(), useAnimation()];

  const handleSpin = () => {
    if (isSpinning) return;

    // Сбрасываем позицию каждого слота в начало без анимации
    controls.forEach(control => {
      control.set({ y: 0 });
    });

    // Генерируем новые индексы и устанавливаем флаг спиннинга
    setStopIndexes([
      getRandomStopIndex(),
      getRandomStopIndex(),
      getRandomStopIndex(),
    ]);
    setIsSpinning(true);

    // Устанавливаем таймер для сброса флага после анимации
    const longestDuration = 3 + 2 * 0.5;
    setTimeout(() => {
      setIsSpinning(false);
    }, longestDuration * 1000);
  };

  useEffect(() => {
    // Этот хук теперь только запускает анимацию, когда isSpinning становится true
    if (isSpinning) {
      controls.forEach((control, i) => {
        // У нас 30 элементов в ленте (10 повторений по 3)
        // Выбираем элемент из 2-го повторения (индексы 20-29), чтобы был запас для прокрутки
        const finalY = -((30 / 3) * 2 + stopIndexes[i]) * 43.33 + 43.33;
        control.start({
          y: finalY,
          transition: {
            delay: i * 0.2,
            duration: 3 + i * 0.5,
            ease: 'easeOut',
          },
        });
      });
    }
  }, [isSpinning, stopIndexes, controls]);

  return (
    <div className={mainPageStyles.spin}>
      <div className={styles.slotsContainer}>
        {controls.map((control, i) => (
          <Slot key={i} id={i} controls={control} />
        ))}
      </div>
      <div
        className={`${mainPageStyles.spinBtn} ${isSpinning ? mainPageStyles.disabled : ''}`}
        onClick={handleSpin}
      ></div>
    </div>
  );
};

export default SlotsContainer;
